"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var close_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/actions/close.svg"));

var done_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/status/done.svg"));

var baseProps_1 = __importDefault(require("../assets/baseProps"));

var withStyles_1 = require("../decorators/withStyles");

var fillIcon_1 = require("../helpers/fillIcon");

var Icon_1 = __importDefault(require("../Icon/Icon"));

var StatusIcon_styles_1 = require("./StatusIcon.styles");

var StatusIcon = function StatusIcon(props) {
  var _a;

  var mode = props.mode,
      classes = props.classes,
      theme = props.theme;
  var themedOkIcon = fillIcon_1.fillIcon(done_svg_1.default, {
    fill: theme.colorIconContrast.normal
  });
  var themedErrorIcon = fillIcon_1.fillIcon(close_svg_1.default, {
    fill: theme.colorIconContrast.normal
  });
  var isOk = mode === 'ok';
  var isError = mode === 'error';
  var cssClass = classnames_1.default(classes.container, (_a = {}, _a[classes.ok] = isOk, _a[classes.error] = isError, _a));
  return react_1.default.createElement("div", __assign({}, baseProps_1.default(props), {
    className: cssClass
  }), isOk && react_1.default.createElement(Icon_1.default, {
    sizeX: 8,
    icon: themedOkIcon,
    testId: "ok"
  }), isError && react_1.default.createElement(Icon_1.default, {
    sizeX: 8,
    icon: themedErrorIcon,
    testId: "error"
  }));
};

exports.default = withStyles_1.withStyles(StatusIcon_styles_1.styles)(StatusIcon);